import React, { createContext, useContext } from 'react';
import { loadStripe } from '@stripe/stripe-js';

const publishableKey = import.meta.env?.VITE_STRIPE_PUBLISHABLE_KEY?.trim();
const isLiveKey = typeof publishableKey === 'string' && publishableKey.startsWith('pk_live_');
const isSecure = typeof window !== 'undefined' && window.location?.protocol === 'https:';
const shouldLoadStripe =
  typeof publishableKey === 'string' &&
  publishableKey.length > 0 &&
  (isSecure || !isLiveKey);
const stripePromise = shouldLoadStripe ? loadStripe(publishableKey) : null;

const StripeContext = createContext({
  stripePromise,
  stripeOptions: {
    appearance: {
      theme: 'stripe',
      variables: { colorPrimary: '#5B21B6' },
    },
  },
});

export const useStripeContext = () => useContext(StripeContext);

export const StripeProvider = ({ children }) => (
  <StripeContext.Provider
    value={{
      stripePromise,
      stripeOptions: {
        appearance: {
          theme: 'stripe',
          variables: { colorPrimary: '#5B21B6' },
        },
      },
    }}
  >
    {children}
  </StripeContext.Provider>
);
